import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getPayRateByLocationCsv } from 'api/pulse/payRateByLocation'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function usePayRateByLocationDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_pay_rate_by_location', {
        filters: query,
      })
      const data = await getPayRateByLocationCsv(query)
      fileDownload(data, 'pay_rate_by_location.csv')
    },
  })
}
